import {Directive, HostListener, ElementRef, Input, OnInit} from '@angular/core';

/**
 *
 * Autofocus element once its loaded
 *
 * @example
 * <input type="text" rc-autofocus />
 */
@Directive({
    selector: '[rc-textarea-autoresize]'
})
export class RcTextareaAutoresizeDirective implements OnInit {

    /**
     * Active / autofocus
     */
    @Input('autoresize') autoresize: boolean = true;

    /**
     * Listen to input event
     * @param HTMLTextAreaElement textArea
     */
    @HostListener('input', ['$event.target'])
    onInput(textArea: HTMLTextAreaElement): void {
        this.adjust();
    }

    constructor(public element: ElementRef) {
    }

    /**
     * On init - adjust height
     */
    ngOnInit(): void {
        this.adjust();
    }

    /**
     * adjust textarea height by text
     */
    adjust(): void {
        const textArea = this.element.nativeElement;
        let newHeight;

        if (textArea) {
            textArea.style.overflow = 'hidden';
            textArea.style.height = 'auto';
            if (this.autoresize) {
                newHeight = textArea.scrollHeight;
                textArea.style.height = newHeight + 'px';
            }
        }
    }

}
